import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import getOrderDetailsQuery from '../../../routes/shop/orderDetails/getOrders.graphql';
import { getPendingOrders } from './getPendingOrders';

/**
 * Action to approve a pending order and immediately dispatch a request to find a driver.
 * @param {number} id - The ID of the booking/order.
 * @param {boolean} isOrderDetailPage - Flag to determine if we need to refetch the order details query.
 */
export default function approveAndSearchDriver(id, isOrderDetailPage = false) {
    return async (dispatch, getState, { client }) => {
        try {
            // This defines the GraphQL mutation we're going to call.
            // Notice it's simpler now, only taking an $id.
            const mutation = gql`
                mutation approveAndSearchDriver($id: Int!) {
                    approveAndSearchDriver(id: $id) {
                        status
                        errorMessage
                        successMessage
                    }
                }
            `;

            // This array holds queries to refetch after the mutation is successful.
            let refetchQueries = [];
            if (isOrderDetailPage) {
                refetchQueries.push({
                    query: getOrderDetailsQuery,
                    variables: { id }
                });
            }

            const { data } = await client.mutate({
                mutation,
                variables: { id }, // We only need to send the ID.
                refetchQueries
            });

            const response = data.approveAndSearchDriver;

            // Handle the different responses from the server.
            if (response && response.status === 200) {
                // Case 1: Everything was successful.
                toastr.success('Success!', response.successMessage);
                // After success, refetch the list of pending orders so the UI updates.
                dispatch(getPendingOrders()); 
            } else if (response && response.status === 404) {
                // Case 2: Order was approved, but no driver was found.
                // This is a warning, not a hard error.
                toastr.warning('Driver Not Found', response.errorMessage);
                dispatch(getPendingOrders()); // Still refetch to update status to "deliveryNotFound".
            } else {
                // Case 3: A genuine error occurred (e.g., validation, server error).
                toastr.error('Error!', response ? response.errorMessage : 'An unknown error occurred.');
            }

            return response;
        } catch (error) {
            // Handle network errors or other exceptions.
            toastr.error('Request Failed', error.message);
            return error;
        }
    }
};